import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../../../model/RootStoreContext';
import { autorun } from 'mobx';
import { IGameEnvironment } from '../../../model/gameEnvironment/GameEnvironment';
import { IDistributionDiffVm } from '@yakoffice/publisher-types';
import { IGameVersion } from '../../../model/gameVersion/GameVersion';
import { DistributionId } from '@yakoffice/publisher-types';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useDistributionDiffResult {
    isLoaded: boolean;
    distributionDiff: IDistributionDiffVm | null;
}

export const useDistributionDiff = (gameVersion: IGameVersion,
                                    gameEnvironment: IGameEnvironment,
                                    distributionId: DistributionId,
                                    diffGameVersion: IGameVersion,
                                    diffGameEnvironment: IGameEnvironment,
                                    diffDistributionId: DistributionId,
                                    refreshToggle: boolean) => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState<useDistributionDiffResult>({ isLoaded: false, distributionDiff: null });

    useEffect(() => {
        autorun(() => {
            setResult({ isLoaded: false, distributionDiff: null });

            rootStore.distributionStore.getDistributionDiff(gameVersion, gameEnvironment, distributionId, diffGameVersion, diffGameEnvironment, diffDistributionId)
                .then((distributionDiff) => {
                    setResult({ isLoaded: true, distributionDiff: distributionDiff });
                })
                .catch(e => publishNotification({
                    text: 'Error loading diff',
                    canClose: true
                }));
        });
    }, [rootStore.distributionStore, publishNotification, gameVersion, gameEnvironment, distributionId, diffGameVersion, diffGameEnvironment, diffDistributionId, refreshToggle]);

    return result;
};
